import type { StateCreator } from '@shared-types/zustand.types';

export type FiltersSlice = {
  filters: Record<string, any>;
  setFilters: (filters: Record<string, any>) => void;
};

export const filtersSlice: StateCreator<FiltersSlice> = (set) => ({
  filters: null,
  setFilters: (filters: Record<string, any>) => set(() => ({ filters }), false, 'setFilters'),
});
